import { ErrorBase } from '@/general/helpers/errorBase';

type CarComparisonStoreErrorName = 'TOO_MANY_SKUS' | 'SKU_NOT_SELECTED';

export class CarComparisonStoreError extends ErrorBase<CarComparisonStoreErrorName> {}
